import { Component, computed, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';
import { ThemeService } from '../../services/theme.service';
import { UserPreferencesService } from '../../services/user-preferences.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {
  private readonly languageService = inject(LanguageService);
  private readonly themeService = inject(ThemeService);
  private readonly userPreferencesService = inject(UserPreferencesService);

  readonly selectedLanguage = this.languageService.language;
  readonly availableLanguages = this.languageService.availableLanguages;

  readonly selectedFormItemsView = this.userPreferencesService.formItemsView;
  readonly availableFormItemsViews = this.userPreferencesService.availableFormItemsViews;

  readonly selectedMode = this.themeService.mode;
  readonly selectedPalette = this.themeService.palette;
  readonly availableModes = this.themeService.availableModes;
  readonly availablePalettes = this.themeService.availablePalettes;

  readonly currentModeOption = computed(() =>
    this.availableModes.find((m) => m.value === this.selectedMode())
  );
  readonly currentPaletteOption = computed(() =>
    this.availablePalettes.find((p) => p.value === this.selectedPalette())
  );

  onLanguageChange(event: MatSelectChange): void {
    if (this.languageService.isSupportedLanguage(event.value)) {
      this.languageService.setLanguage(event.value);
    }
  }

  onFormItemsViewChange(event: MatSelectChange): void {
    if (this.userPreferencesService.isSupportedFormItemsView(event.value)) {
      this.userPreferencesService.setFormItemsView(event.value);
    }
  }

  onModeChange(event: MatSelectChange): void {
    if (this.themeService.isSupportedMode(event.value)) {
      this.themeService.setMode(event.value);
    }
  }

  onPaletteChange(event: MatSelectChange): void {
    if (this.themeService.isSupportedPalette(event.value)) {
      this.themeService.setPalette(event.value);
    }
  }
}
